import { render, staticRenderFns } from "./NodeStartCar.vue?vue&type=template&id=2a16a196&scoped=true"
import script from "./NodeStartCar.vue?vue&type=script&lang=js"
export * from "./NodeStartCar.vue?vue&type=script&lang=js"
import style0 from "./NodeStartCar.vue?vue&type=style&index=0&id=2a16a196&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16a196",
  null
  
)

export default component.exports